import React, { useEffect } from "react";
import Layout from "./Layout";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { getMe } from "../features/authSlice.js";
import AdminSection from "../sections/AdminSection.jsx";

const Admin = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { user, isError } = useSelector((state) => state.auth);

  useEffect(() => {
    dispatch(getMe());
  }, [dispatch]);

  useEffect(() => {
    if (isError && !user) {
      navigate("/");
    }
  }, [isError, user, navigate]);

  return (
    <>
      <Layout>
        <AdminSection />
      </Layout>
    </>
  );
};

export default Admin;
